import { gql, useMutation } from "@apollo/client";

import { BatchArchiveAssetsInput } from "../../../generated/gql/graphql";

const BATCH_ARCHIVE_ASSETS = gql`
  mutation BatchArchiveAssets($input: BatchArchiveAssetsInput!) {
    batchArchiveAssets(input: $input)
  }
`;

type AssetsApi = {
  archiveAssets(ids: string[]): Promise<void>;
};

export default function useAssets(): AssetsApi {
  const [batchArchiveAssetsMut] =
    useMutation<BatchArchiveAssetsInput>(BATCH_ARCHIVE_ASSETS);

  async function archiveAssets(ids: string[]): Promise<void> {
    if (ids.length === 0) {
      return Promise.resolve();
    }

    await batchArchiveAssetsMut({
      variables: {
        input: {
          assetIds: ids,
        },
      },
    });
  }

  return {
    archiveAssets,
  };
}
